
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileIconFooter = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 40,
  width: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "18 9 22.3 39.34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.328 48.344H19.967A1.969 1.969 0 0 1 18 46.377v-35.41C18 9.882 18.882 9 19.967 9h18.361c1.085 0 1.967.882 1.967 1.967v35.41a1.969 1.969 0 0 1-1.967 1.967zm.656-37.377a.657.657 0 0 0-.656-.656H19.967a.656.656 0 0 0-.656.656v3.278h19.674v-3.278h-.001zm-19.673 4.59h19.674v23.606H19.311V15.557zm19.673 24.919H19.311v5.901c0 .362.294.656.656.656h18.361a.657.657 0 0 0 .656-.656v-5.901zm-11.803 3.278a1.97 1.97 0 0 0 1.967 1.968 1.97 1.97 0 0 0 1.967-1.968 1.97 1.97 0 0 0-1.967-1.967 1.97 1.97 0 0 0-1.967 1.967zm1.967-.655a.656.656 0 1 0 0 1.311.656.656 0 0 0 0-1.311zm1.31-31.476h-2.623a.655.655 0 1 0 0 1.311h2.623a.656.656 0 1 0 0-1.311z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"40\" width=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"18 9 22.3 39.34\">     <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.328 48.344H19.967A1.969 1.969 0 0 1 18 46.377v-35.41C18 9.882 18.882 9 19.967 9h18.361c1.085 0 1.967.882 1.967 1.967v35.41a1.969 1.969 0 0 1-1.967 1.967zm.656-37.377a.657.657 0 0 0-.656-.656H19.967a.656.656 0 0 0-.656.656v3.278h19.674v-3.278h-.001zm-19.673 4.59h19.674v23.606H19.311V15.557zm19.673 24.919H19.311v5.901c0 .362.294.656.656.656h18.361a.657.657 0 0 0 .656-.656v-5.901zm-11.803 3.278a1.97 1.97 0 0 0 1.967 1.968 1.97 1.97 0 0 0 1.967-1.968 1.97 1.97 0 0 0-1.967-1.967 1.97 1.97 0 0 0-1.967 1.967zm1.967-.655a.656.656 0 1 0 0 1.311.656.656 0 0 0 0-1.311zm1.31-31.476h-2.623a.655.655 0 1 0 0 1.311h2.623a.656.656 0 1 0 0-1.311z\" fill=\"var(--theme-primary, #810ea9)\"></path>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobile-icon-footer.5b3584e0585b32d6528bc5a865b97a82.svg"),
        {
          React: SvgMobileIconFooter,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      